import urljoin from 'url-join';
import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import { AddOrReplaceMessagingWorkspaceRequest } from './models/addOrReplaceMessagingWorkspaceRequest';
import { MessagingWorkspaceModel } from '@/messaging/models/messagingWorkspaceModel';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';
import { CreateContactAttributeViewModel } from '@/messaging/models/createContactAttributeViewModel';
import { GetAttributesViewModel } from '@/messaging/models/getAttributesViewModel';
import { UpdateContactAttributeViewModel } from '@/messaging/models/updateContactAttributeViewModel';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';

class MessagingWorkspacesApi {
  private version = 'v1';

  public getWorkspace(workspaceId: string): Promise<MessagingWorkspaceModel> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId);
    return api.send('GET', url);
  }

  public addOrReplace(request: AddOrReplaceMessagingWorkspaceRequest): Promise<MessagingWorkspaceModel> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces');
    return api.send('PATCH', url, request);
  }

  public async getAttributesForWorkspace(workspaceId: string): Promise<GetAttributesViewModel> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId, 'attributes');
    return api.send('GET', url);
  }

  public async createAttributeForWorkspace(
    workspaceId: string,
    request: CreateContactAttributeViewModel,
  ): Promise<ContactAttributeViewModel> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId, 'attributes');
    return api.send('POST', url, request);
  }

  public async updateAttributeForWorkspace(
    workspaceId: string,
    attributeId: string,
    request: UpdateContactAttributeViewModel,
  ): Promise<ContactAttributeViewModel> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId, 'attributes', attributeId);
    return api.send('PATCH', url, request);
  }

  public async archiveAttributeForWorkspace(workspaceId: string, attributeId: string): Promise<any> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId, 'attributes', attributeId);
    return api.send('DELETE', url);
  }

  public async getChannelIdentities(workspaceId: string): Promise<ChannelIdentityViewModel[]> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId, 'channel-identities');
    return api.send('GET', url);
  }
}

export const messagingWorkspacesApi = new MessagingWorkspacesApi();
